import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
import * as _moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Router } from "@angular/router";
import { CustomPDFs } from "../main/pages/_sommavi/services/PDF/CustomPDFs";
import { time } from "console";
import { ToastTypeEnum } from "app/main/pages/_sommavi/_commons/enums";
import { CustomRecuToPDFs } from "app/main/pages/_sommavi/services/PDF/RecuToPDFs";

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  constructor(
    private _toastr: ToastrService,
    private _router: Router,
    private _translate: TranslateService
  ) {}

  showSwalToast(type: string, title: string, body) {
    const titleContent = title ? `${title}` : "";
    if (type === "success") {
      Swal.fire({
        title: title,
        text: body,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else {
      Swal.fire({
        title: title,
        text: body,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }

  showToastrToast(type: string, title: string, body: string, duration: number) {
    if (type === "success") {
      this._toastr.success(body, title, {
        timeOut: duration,
        toastClass: "toast ngx-toastr",
        closeButton: true,
      });
    } else if (type === "warning") {
      this._toastr.warning(body, title, {
        timeOut: duration,
        toastClass: "toast ngx-toastr",
        closeButton: true,
      });
    } else if (type === "error") {
      this._toastr.error(body, title, {
        timeOut: duration,
        toastClass: "toast ngx-toastr",
        closeButton: true,
      });
    }
  }

  handleErrorResponse(error) {
    let message = error.error.message;
    if (error.status == 0) {
      message = "Impossible de joindre le serveur !";
    } else if (error.status === 403) {
      if (error.error.message === undefined || error.error.message === null)
        message =
          "Impossible d'effectuer la requête vous n'avez pas les droits requis !";
    } else if (error.status === 500) {
      message =
        "Une erreur interne du système est survenue, veuillez réessayer. Si le problème persiste contacter l'équipe de support.";
    }
    Swal.fire({
      title: "",
      text: message,
      icon: "error",
      customClass: {
        confirmButton: "btn btn-success",
      },
    });
  }

  static Toastandler(type: string, message: string, time?: number) {
    // @ts-ignore
    Swal.fire({
      position: "top",
      title: "",
      html: message,
      icon: type,
      allowOutsideClick: false,
      // customClass: {
      //   confirmButton: "btn btn-primary",
      // },
      showConfirmButton: true,
      timer: !!time ? time : null,
    });
  }

  formatDate(date) {
    date = [date.year, date.month, date.day];
    return _moment(date, "yyyy-MM-DD").format("yyyy-MM-DD");
  }

  formatDateCustom(date, format) {
    date = [date.year, date.month, date.day];
    return _moment(date, "yyyy-MM-DD").format(format);
  }

  formatDateCalendar(date) {
    let dates = date.split("-");
    return {
      year: Number(dates[0]),
      month: Number(dates[1]),
      day: Number(dates[2]),
    };
  }

  static addDayToDate(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  //============================================================================================
  //=================================MY PROJET====================================================
  //============================================================================================

  //-> RECHERCHE MULTI-TERMES EN MEMOIRE (COMME L'API) : "-2.25 0.25" -> CHAQUE TERME DOIT ETRE PRESENT
  //   DANS AU MOINS UN DES TEXTES ; LA VIRGULE DECIMALE EST ACCEPTEE ("-2,25" = "-2.25")
  static correspondRecherche(textes: any[], recherche: string): boolean {
    const termes = String(recherche || "").replace(/(\d),(\d)/g, "$1.$2").toLowerCase().trim().split(/\s+/).filter((t) => t.length > 0);
    if (termes.length === 0) return true;
    const contenu = textes.filter((t) => t !== null && t !== undefined).join(" ").replace(/(\d),(\d)/g, "$1.$2").toLowerCase();
    return termes.every((t) => contenu.includes(t));
  }

  static not_undefined(element) {
    return (
      element === null ||
      element === "" ||
      element === "" ||
      element === undefined ||
      element === [] ||
      element === {}
    );
  }

  static AlertMessageHandler(response: any) {
    console.log("response -->", response);
    let type = "success";
    const errorStat: boolean = response.hasOwnProperty("error");
    if (errorStat) {
      if (response.error.status != "OK") {
        type = "error";
      }
    } else {
      if (response.status != "OK") {
        type = "error";
      }
    }

    // @ts-ignore
    Swal.fire({
      title: "",
      html: errorStat ? response.error.message : response.message,
      icon: type,
      allowOutsideClick: false,
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  }

  static CustomAlertMessageHandler(type: string, message: string) {
    // @ts-ignore
    Swal.fire({
      title: "",
      html: message,
      icon: type,
      allowOutsideClick: false,
    });
  }

  //-> for me
  static ConfirmToast(message: string, fn) {
    // @ts-ignore
    Swal.fire({
      title: "",
      text: message,
      icon: ToastTypeEnum.QUESTION,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      // allowOutsideClick: false,
      cancelButtonColor: "#d33",
      reverseButtons: true,
      cancelButtonText: "Non!",
      confirmButtonText: "Oui, continuer!",
    }).then((result) => {
      if (result.isConfirmed) {
        fn();
      }
    });
  }


  static handleApiErrorResponse(error) {
    let message = error.error.message;
    if (error.status == 0) {
      message = "Impossible de joindre le serveur !";
    } else if (error.status === 403) {
      if (error.error.message === undefined || error.error.message === null)
        message =
          "Impossible d'effectuer la requête vous n'avez pas les droits requis !";
    } else if (error.status === 500) {
      message =
        "Une erreur interne du système est survenue, veuillez réessayer. Si le problème persiste contacter l'équipe de support.";
    }
    Swal.fire({
      title: "",
      text: message,
      icon: "error",
      customClass: {
        confirmButton: "btn btn-success",
      },
    });
  }

  //is my
  static genererChaineAleatoire(longueur: number): string {
    let resultat = "";
    const caracteres =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const caracteresLength = caracteres.length;
    for (let i = 0; i < longueur; i++) {
      resultat += caracteres.charAt(
        Math.floor(Math.random() * caracteresLength)
      );
    }
    return resultat;
  }

  static removeDuplicateInString(str, n) {
    // Used as index in the modified string
    let index = 0;

    // Traverse through all characters
    for (let i = 0; i < n; i++) {
      // Check if str[i] is present before it
      let j;
      for (j = 0; j < i; j++) {
        if (str[i] == str[j]) {
          break;
        }
      }

      // If not present, then add it to
      // result.
      if (j == i) {
        str[index++] = str[i];
      }
    }

    return str.join("").slice(str, index);
  }

  public static DateConvert(date) {
    let result = date;
    if (typeof date !== "string") {
      // tslint:disable-next-line:max-line-length
      result =
        date[0] +
        (date[1].toString().length <= 1 ? "-0" : "-") +
        date[1] +
        (date[2].toString().length <= 1 ? "-0" : "-") +
        date[2];
    }
    return result;
  }

  static checkIfAsRole(userData: any, RoleArr?: any) {
    let result = false;
    let MyRoles = [];
    if (Array.isArray(userData.roles)) {
      for (let rll of userData.users.roles) {
        MyRoles.push(rll.nom.toString());
      }

      for (let reqRole of RoleArr) {
        if (MyRoles.includes(reqRole)) {
          result = true;
        }
      }
    } else result = RoleArr.includes(userData.roles.nom.toString());

    return result;
  }

  /**
   * EXEMPLE de titleData
   * // const titleData = [
    //   { note: titre },
    //   { note: "type : , Initié par this.DataEcart.createur.nom" },
    //   // {"note": "Département : "+ this.DataEcart.createur.departements.code+" "+this.DataEcart.createur.departements.nom },
    //   { note: "Date d'incentaire : " },
    // ];
   * 
   */
  public static ExportExcel(apiData, fileName, origin, titleData?) {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // export = XLSX.utils.json_to_sheet({});
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_json(ws, apiData, {
      skipHeader: false,
      origin: origin,
    });

    if (!UtilsService.not_undefined(titleData)) {
      XLSX.utils.sheet_add_json(ws, titleData, {
        header: ["note"],
        skipHeader: true,
        origin: "A1",
      });
    }
    // XLSX.utils.json_to_sheet(apiData);
    // ws.addRow(["AZERTY"]);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }

  public static Print(titre) {
    let printContents, popupWin;
    printContents = document.getElementById("print").innerHTML.toString();
    printContents = (<string>printContents + "");//.replace("col-sm", "col-xs");
    // console.log(printContents);
    popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
    // popupWin.document.open();
    // popupWin.document.write(CustomPDFs.transferStockPDF(printContents, titre));
    popupWin.document.write(CustomRecuToPDFs.transferStockPDF(printContents, titre));
    /* window.close(); */
    popupWin.document.close();
  }

  public Navigate(url, param) {
    this._router.navigate(url, { queryParams: { param: param } }); // 1
  }
}
